module.exports = __webpack_public_path__ + "fonts/barlow-v5-latin-700.46623c8.woff";